import * as React from "react";
import Header from "../components/common/header/Header";
import Footer from "../components/common/Footer/Footer";
import VehicleDetail from "../components/common/VehicleDetails/VehicleDetail";
import { Box, Grid } from "@mui/material";
import Assemblies, {
  AssembliesTab,
} from "../components/common/Assemblies/Assemblies";

const AssembliesPage = () => {
  const [activeTab, setActiveTab] = React.useState<AssembliesTab>("tecdoc");
  const [vehicleHash, setVehicleHash] = React.useState<string | null>(null);

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const hash = params.get("vehicleHash");
    setVehicleHash(hash);
    if (hash) {
      setActiveTab("diagram");
    }
  }, []);

  const diagramWorkspace = activeTab === "diagram" && !!vehicleHash;

  return (
    <>
      <Header />
      <Box sx={{ m: diagramWorkspace ? 1 : 2 }}>
        {diagramWorkspace ? (
          // Full-width 4-zone layout: vehicle | (groups + diagram + parts)
          <Grid container spacing={1.5} alignItems="flex-start">
            <Grid item xs={12} md={2} lg={2}>
              <VehicleDetail />
            </Grid>
            <Grid item xs={12} md={10} lg={10}>
              <Assemblies
                activeTab={activeTab}
                onTabChange={setActiveTab}
                workspaceLayout
              />
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={2.5}>
              <VehicleDetail />
            </Grid>
            <Grid item xs={12} sm={12} md={9.5}>
              <Assemblies
                activeTab={activeTab}
                onTabChange={setActiveTab}
              />
            </Grid>
          </Grid>
        )}
      </Box>
      <Footer />
    </>
  );
};

export default AssembliesPage;
